import React from 'react';
import { RouteComponentProps, withRouter, useHistory } from 'react-router-dom';
import { useUserContext } from '../Components/StateContext/UserContext';

const MedlemskontingentView: React.FC<RouteComponentProps> = () => {
  const history = useHistory();
  const { user } = useUserContext();
  const isLoggedIn = user?.Id != null;

  const handleBliMedlem = () => {
    history.push(isLoggedIn ? '/myuserdetails' : '/register');
  };

  return (
    <div className="ods-margin-top-25 ods-grid ods-grid--gap ods-grid--center">
      <div className="ods-grid__column--12 ods-grid__column--start-3-breakpoint-medium ods-grid__column--end-11-breakpoint-medium">
        <div className="ods-status-card">
          <div className="ods-status-card__content">
            <h1 className="ods-status-card__heading">Medlemskontingent</h1>
            <p>
              Som betalende medlem får barnet ditt tilgang til tamilskolen og til
              aktivitetene og arrangementene våre gjennom året.
            </p>

            <h3 className="ods-margin-top-11">Dette får barnet ditt tilgang til</h3>
            <ul>
              <li>Tamilskole</li>
              <li>Thai Pongal</li>
              <li>Friidrett (Athletics)</li>
              <li>Tamileksamen</li>
              <li>Aandu Vila</li>
            </ul>

            <h3 className="ods-margin-top-11">Pris og betaling</h3>
            <p>
              Medlemskontingenten er <strong>100 kr per barn per år</strong>, og
              betales med <strong>Vipps</strong>.
            </p>

            <div className="ods-margin-top-19 ods-text--align-center">
              <button className="ods-button" onClick={handleBliMedlem}>
                Bli medlem
              </button>
            </div>

            <p className="ods-margin-top-11 ods-text--align-center">
              <a href="/salgsvilkar" className="o-kom-link">Salgsvilkår</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(MedlemskontingentView);
